import { Button, Spacer } from '@qbe/ads-core';
import React, { useState } from 'react';

import pciPalLogo from '~/assets/images/pcipal.png';
import { useAppContent, useAppSelector } from '~/hooks';
import { selectIsStaff } from '~/selectors/selectAppDetails';

import CreditCardContainer from '../DigitalPayments/CreditCardContainer';
import { PciModal } from '../Pci/PciModal';

interface CreditCardPaymentProps {
  onSubmitPayment: () => Promise<unknown>;
}

export const CreditCardPayment = ({ onSubmitPayment }: CreditCardPaymentProps) => {
  const { getTextContent } = useAppContent({
    basePath: 'dsme.creditCardForm.fields.pciPalButton',
  });

  const isStaff = useAppSelector(selectIsStaff);

  const [showModal, setShowModal] = useState(false);

  const showPciModal = () => {
    setShowModal(true);
  };

  const hidePciModal = () => {
    setShowModal(false);
  };

  return isStaff ? (
    <>
      <Button
        onClick={showPciModal}
        data-track="picpal payment"
        startIcon={
          <img
            style={{
              height: '1rem',
              lineHeight: 1,
              marginRight: '0.5rem',
              fontSize: 'inherit',
            }}
            src={pciPalLogo}
            alt={getTextContent('description')}
          />
        }
        label={getTextContent('title')}
      />
      <Spacer size="xs" />
      {showModal && <PciModal onClose={hidePciModal} />}
    </>
  ) : (
    <CreditCardContainer onSubmitPayment={onSubmitPayment} />
  );
};
